import React, { useEffect, useRef } from "react";
import "./Modal.css";
import * as elementUtils from "../../../utils/elementUtils";
import ModalDividerLine from "./modal-divider-line";

export const defaultModalProps = {
  id: "id",
  class: "",
  isActive: false,
  header: "header",
  message: "message",
  headerFontSize: 25,
  messageFontSize: 15,
  icon: undefined,
  iconLeft: false,
  iconHeight: undefined,
  iconAsButton: false,
  onIconClick: () => {},
  textAlign: "left",
  showDivider: true,
  animate: true,
  animationTime: 300,
  bg_opacity: 0.5,
  height: undefined,
  width: undefined,
  children: null,
  onClickOut: () => {},
  onClickOut: () => {},
  onCloseModal: () => {},
  forceUpdate: () => {},
};

export function Modal(props = defaultModalProps) {
  //state
  const activeRef = useRef(props.isActive);
  const renderCountRef = useRef(0);
  var animationTime = defaultModalProps.animationTime;

  useEffect(() => {
    const modal = document.querySelector("#" + props.id);

    if (props.animationTime !== undefined && props.animate) {
      animationTime = props.animationTime;
    }

    //set css based on props
    SetCSSValues();
    //ToggleActiveLogic
    ToggleLogic();

    renderCountRef.current += 1;
  }, [props.isActive]);

  function AnimateActive() {
    const modal_bg = document.querySelector("#" + props.id);
    const modal = modal_bg.querySelector(".generic-modal");
    //fade in bg
    elementUtils.fadeIn(modal_bg, animationTime, 1, "flex");
    //fade in modal inner
    elementUtils.fadeIn(modal, animationTime, 1, "block");
    //move modal inner from above center to  center vertically
    elementUtils.moveElement(modal, animationTime, { top: "-500px" }, { top: "50%" });
  }

  function SetModalActive() {
    const modal_bg = document.querySelector("#" + props.id);
    modal_bg.style.display = "flex";
  }

  function AnimateInactive() {
    const modal_bg = document.querySelector("#" + props.id);
    const modal = modal_bg.querySelector(".generic-modal");
    //move modal inner from above center to  center vertically
    elementUtils.moveElement(modal, animationTime, { top: "50%" }, { top: "-500px" });
    //fade out bg
    elementUtils.fadeOut(modal_bg, animationTime, props.bg_opacity);
    //fade out modal inner
    elementUtils.fadeOut(modal, animationTime, 0);
  }

  function SetModalInActive() {
    const modal_bg = document.querySelector("#" + props.id);
    modal_bg.style.display = "none";
  }

  function RenderChildrenComponents() {
    if (props.children) {
      return props.children;
    }
  }

  function ToggleLogic() {
    if (props.isActive && (activeRef.current === false || renderCountRef.current === 0)) {
      if (props.animate) {
        AnimateActive();
      } else {
        SetModalActive();
      }
      activeRef.current = true;
    }

    if (!props.isActive && activeRef.current === true) {
      if (props.animate) {
        AnimateInactive();
      } else {
        SetModalInActive();
      }
      activeRef.current = false;
    }
  }

  function SetCSSValues() {
    const modal = document.querySelector("#" + props.id);

    if (props.height !== undefined) {
      modal.querySelector("section").style.height = props.height;
    }

    if (props.width !== undefined) {
      modal.querySelector("section").style.width = props.width;
    }

    if (props.iconLeft) {
      let header = modal.querySelector(".generic-modal-header-row");
      header.style.flexDirection = "row-reverse";
      header.style.justifyContent = "flex-end";
    }

    if (props.iconHeight) {
      let icon = modal.querySelector(".modal-icon");
      icon.style.height = props.iconHeight;
      icon.style.width = "auto";
    }

    if (props.textAlign != undefined) {
      modal.style.textAlign = props.textAlign;
    }

    if (props.bg_opacity != undefined) {
      modal.style.backgroundColor = `rgba(0, 0, 0, ${props.bg_opacity})`;
      modal.querySelector("section").style.opacity = 1;
    }

    //set opacity of main modal based on if animate T/F
    if (props.animate) {
      modal.style.opacity = 0;
      let inner_modal = modal.querySelector("section");
      inner_modal.style.position = "absolute";
      inner_modal.style.opacity = 0;
    }

    //show/hide divider in modal
    if (!props.showDivider) {
      let dividers = modal.querySelectorAll(".generic-modal-divider");
      dividers.forEach((element) => {
        element.style.display = "none";
      });
    }
  }

  function RenderIcon() {
    if (props.icon) {
      if (props.iconAsButton === true) {
        let f = () => {};
        if (props.onIconClick) f = props.onIconClick;
        return (
          <button onClick={f} className="standard-button btn-white trash-button ">
            <img className="modal-icon" src={props.icon} alt="modal icon" />
          </button>
        );
      } else {
        return <img className="modal-icon" src={props.icon} alt="modal icon" />;
      }
    }
  }

  return (
    <div id={props.id} className="generic-modal-bg" onClick={props.onClickOut}>
      <section
        className={["generic-modal", props.class ?? ""].join(" ")}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="generic-modal-header-row">
          <h1 className="generic-modal-header">{props.header}</h1>
          {RenderIcon()}
        </div>
        <ModalDividerLine showDivider={props.showDivider} />
        <p className="generic-modal-text">{props.message}</p>
        <ModalDividerLine showDivider={props.showDivider && props.message} />
        {RenderChildrenComponents()}
      </section>
    </div>
  );
}
